import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { PageBrandingService } from '@core/services/page-branding.service';

const PQRS_PATH = 'public/pqrs';
const DEFAULT_TITLE = 'MunilyWebpageAI';

@Component({
  selector: 'munily-ia-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  title = DEFAULT_TITLE;
  private router = inject(Router);
  private pageBranding = inject(PageBrandingService);
  private sub?: Subscription;

  ngOnInit(): void {
    this.sub = this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    ).subscribe((e) => {
      if (!e.urlAfterRedirects.includes(PQRS_PATH)) {
        this.pageBranding.resetToDefault();
      }
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
